import { get, patch, post } from '../../utils/http';

export const fetchOrderChatMessages = ({ accountId, orderId }) =>
  get(`/accounts/${accountId}/orders/${orderId}/messages`);

export const addOrderChatMessage = ({ accountId, orderId, message, isClient }) =>
  post(`/accounts/${accountId}/orders/${orderId}/messages`, { message, isClient });

export const editOrderChatMessage = ({ accountId, orderId, messageId, status }) =>
  patch(`/accounts/${accountId}/orders/${orderId}/messages/${messageId}`, { status });
